import { useEffect, useState } from 'react';
import fetchDataWithTimeout from './fetchDataWithTimeout';

export const useFetch = (sendRequest, handleError, timeout, propToWatch) => {
  const [body, setBody] = useState({});
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      let responseBody;
      if (timeout) {
        responseBody = await fetchDataWithTimeout(sendRequest, null, timeout);
      } else {
        responseBody = await sendRequest();
      }
      setBody(responseBody);
    } catch (e) {
      handleError(e);
      setError(e);
    }
  };

  useEffect(() => {
    setBody({});
    setError(null);
    fetchData();
  }, [propToWatch]);

  return {
    body,
    error,
  };
};
